var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTextfieldEyeHidden(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00008 3.5C8.53051 3.5 9.03922 3.71071 9.41429 4.08579C9.78937 4.46086 10.0001 4.96957 10.0001 5.5C10.0001 6.03043 9.78937 6.53914 9.41429 6.91421C9.03922 7.28929 8.53051 7.5 8.00008 7.5C7.46965 7.5 6.96094 7.28929 6.58587 6.91421C6.21079 6.53914 6.00008 6.03043 6.00008 5.5C6.00008 4.96957 6.21079 4.46086 6.58587 4.08579C6.96094 3.71071 7.46965 3.5 8.00008 3.5ZM8.00008 0.5C11.3334 0.5 14.1801 2.57333 15.3334 5.5C14.1801 8.42667 11.3334 10.5 8.00008 10.5C4.66675 10.5 1.82008 8.42667 0.666748 5.5C1.82008 2.57333 4.66675 0.5 8.00008 0.5ZM2.12008 5.5C2.65892 6.6002 3.49562 7.52717 4.53507 8.1755C5.57452 8.82384 6.77501 9.16755 8.00008 9.16755C9.22515 9.16755 10.4256 8.82384 11.4651 8.1755C12.5045 7.52717 13.3412 6.6002 13.8801 5.5C13.3412 4.3998 12.5045 3.47283 11.4651 2.8245C10.4256 2.17616 9.22515 1.83245 8.00008 1.83245C6.77501 1.83245 5.57452 2.17616 4.53507 2.8245C3.49562 3.47283 2.65892 4.3998 2.12008 5.5Z",
    fill: "#A7ACB1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTextfieldEyeHidden);
export default __webpack_public_path__ + "static/media/icon-textfield-eye-hidden.32932db7453fe66b92e001b37e6fe247.svg";
export { ForwardRef as ReactComponent };